import { Routes } from '@angular/router';
import { accountHistoryResolver } from '@df/account/resolvers/account-history.resolver';
import { countriesListResolver } from '@df/api/config/contries-list.resolver';
import { CustomerHistoryOrderResolver } from '@df/session/customer/customer-history-order.resolver';
import { CustomerHistoryResolver } from '@df/session/customer/customer-history.resolver';
import { CustomerLoggedGuard } from '@df/session/customer/customer-logged.guard';
import { WishlistLoadResolver } from '@df/session/wishlist/wishlist-load.resolver';
import { AccountAddressBookComponent } from './address/book/account-address-book.component';
import { AccountAddressEditComponent } from './address/edit/account-address-edit.component';
import { AccountDashboardComponent } from './dashboard/account-dashboard.component';
import { AccountEditComponent } from './edit/account-edit.component';
import { AccountEditEmailComponent } from './edit/email/account-edit-email.component';
import { AccountEditPasswordComponent } from './edit/password/account-edit-password.component';
import { AccountEditPersonalComponent } from './edit/personal/account-edit-personal.component';
import { AccountEditPreferredStoreComponent } from './edit/preferred-store/account-edit-preferred-store.component';
import { AccountMarketingPreferencesComponent } from './marketing-preferences/account-marketing-preferences.component';
import { AccountOrderHistoryComponent } from './order/history/account-order-history.component';
import { AccountOrderViewComponent } from './order/view/account-order-view.component';
import { AccountSavedCardBookComponent } from './saved-card/book/account-saved-card-book.component';
import { AccountViewComponent } from './view/account-view.component';
import { AccountWishlistComponent } from './wishlist/account-wishlist.component';

export const accountRoutes: Routes = [
    {
        path: '',
        component: AccountViewComponent,
        canActivate: [CustomerLoggedGuard],
        children: [
            {
                path: '',
                pathMatch: 'full',
                component: AccountDashboardComponent,
                resolve: {
                    appMore: countriesListResolver,
                    history: accountHistoryResolver
                }
            },
            {
                path: 'edit',
                component: AccountEditComponent
            },
            {
                path: 'edit/email',
                component: AccountEditEmailComponent
            },
            {
                path: 'edit/password',
                component: AccountEditPasswordComponent
            },
            {
                path: 'edit/personal',
                component: AccountEditPersonalComponent
            },
            {
                path: 'edit/preferred-store',
                component: AccountEditPreferredStoreComponent
            },
            {
                path: 'payment-methods',
                component: AccountSavedCardBookComponent
            },
            {
                path: 'address-book',
                component: AccountAddressBookComponent,
                resolve: {
                    appMore: countriesListResolver
                }
            },
            {
                path: 'address',
                component: AccountAddressEditComponent,
                resolve: {
                    appMore: countriesListResolver
                }
            },
            {
                path: 'address/:id',
                component: AccountAddressEditComponent,
                resolve: {
                    appMore: countriesListResolver,
                }
            },
            {
                path: 'my-orders',
                component: AccountOrderHistoryComponent,
                resolve: {
                    appMore: countriesListResolver,
                    history: CustomerHistoryResolver
                }
            },
            {
                path: 'my-orders/:id',
                component: AccountOrderViewComponent,
                resolve: {
                    appMore: countriesListResolver,
                    historyOrder: CustomerHistoryOrderResolver
                }
            },
            {
                path: 'wishlist',
                component: AccountWishlistComponent,
                resolve: {
                    wishlist: WishlistLoadResolver
                }
            },
            {
                path: 'marketing-preferences',
                component: AccountMarketingPreferencesComponent
            }
        ]
    }
];
